// extracted by mini-css-extract-plugin
export default {"note":"OwnNumberNote_note__euIGf"};